// 删除数组相同的元素
function deleteObject(arr) {
    let uniques = [];
    let stringify = {};
    for (let i = 0; i < arr.length; i++) {
        let keys = Object.keys(arr[i]);
        keys.sort(function(a, b) {
            return (Number(a) - Number(b));
        });
        let str = '';
        for (let j = 0; j < keys.length; j++) {
            str += JSON.stringify(keys[j]);
            str += JSON.stringify(arr[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
            uniques.push(arr[i]);
            stringify[str] = true;
        }
    }
    uniques = uniques;
    return uniques;
}

// 取小数点后几位不四舍五入;
function formatDecimal(num, decimal) {
    num = num.toString()
    let index = num.indexOf('.')
    if (index !== -1) {
        num = num.substring(0, decimal + index + 1)
    } else {
        num = num.substring(0)
    }
    return parseFloat(num).toFixed(decimal)
}

/**
 * 验证身份证号
 * @param card 身份证号
 * @returns {boolean} true: 合法 false: 不合法
 */
function regCard(card) {
    let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    if (reg.test(card)) {
        return true
    } else {
        return false;
    }
}

/**
 * 验证银行卡号
 * @param bank  银行卡号
 * @returns {boolean} true 正确 false 不正确
 */
function regBank(bank) {
    let reg = /^([1-9]{1})(\d{15}|\d{18})$/;
    if(reg.test(bank)) {
        return true
    }else {
        return false;
    }
}

/**
 * 格式化数字
 * @param num  需要格式化的数字
 * @returns {string} 返回的格式化的数字
 */
function toThousands(num) {
    let arr = num.toString().split('.');
    let new_num = arr[0];
    let result = '';
    while (new_num.length > 3) {
        result = ',' + new_num.slice(-3) + result;
        new_num = new_num.slice(0, new_num.length - 3);
    }
    if (new_num) { result = new_num + result; }
    if(arr[1]) {
        return result + '.' + arr[1].substr(0,4)
    }else {
        return result;
    }
}

/**
 * 检测手机号
 * @param mobile 手机号
 * @returns {boolean}   合法为true
 */
function regMobile(mobile) {
    let reg = /^1[3456789]\d{9}$/;
    if (reg.test(mobile.trim())) {
        return true;
    } else {
        return false;
    }
}

/**
 * 验证邮箱
 * @param value 需要验证的邮箱
 * @returns {boolean}   true 验证通过  false 验证不通过
 */
function regEmail (value){
    return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value.trim());
}

/**
 *  根据身份证号获取生日，性别，年龄
 * @param card_num  身份证号
 * @return {object} 包含身份信息的对象
 */
function discriCard(card_num) {
    let info_data = {}
    // 获取生日
    info_data.birthday = card_num.substring(6, 10) + "-" + card_num.substring(10, 12) + "-" + card_num.substring(12, 14);
    //获取性别
    if (parseInt(card_num.substr(16, 1)) % 2 == 1) {
        info_data.sex = '男'
    } else {
        info_data.sex = '女'
    }
    //获取年龄
    var myDate = new Date();
    var month = myDate.getMonth() + 1;
    var day = myDate.getDate();
    info_data.age = myDate.getFullYear() - card_num.substring(6, 10) - 1;
    if (card_num.substring(10, 12) < month || card_num.substring(10, 12) == month && card_num.substring(12, 14) <= day) {
        info_data.age++;
    }

    return info_data;
}

/**
 * 时间格式化函数
 * @param fmt 时间
 * @returns {string} 时间格式
 */
function formatDate(fmt) {
    // console.log(fmt);
    const date = new Date(fmt);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return year + '-' + month + '-' + day;
};

/**
 * 截取code
 * @param name
 * @param url
 * @returns {string | null}
 */
function getUrlKey(name,url){
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
};

/**
 * 判断是否为手机端
 */
function isMobile() {
    let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return mobile != null
}

export {
    deleteObject,
    regCard,
    regMobile,
    regEmail,
    discriCard,
    formatDate,
    regBank,
    getUrlKey,
    toThousands,
    formatDecimal,
    isMobile
}
